import { render, staticRenderFns } from "./CustomerAccounts.vue?vue&type=template&id=bd29f28a&scoped=true&"
import script from "./CustomerAccounts.vue?vue&type=script&lang=js&"
export * from "./CustomerAccounts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAccounts.vue?vue&type=style&index=0&id=bd29f28a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd29f28a",
  null
  
)

export default component.exports